import type { Movie } from '@/types/media';

export const movies: Movie[] = [
  {
    id: 'ml-01',
    title: '星河彼岸',
    category: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20movie%20poster%2C%20lone%20astronaut%20silhouette%20before%20a%20glowing%20spiral%20galaxy%2C%20deep%20green%20and%20amber%20nebula%2C%20volumetric%20light%20rays%2C%20moody%20vertical%20composition%2C%20ultra%20detailed%20concept%20art&width=600&height=900&seq=nc-movie-01&orientation=portrait',
    genre: ['科幻', '冒险', '剧情'],
    year: 2026,
    region: '中国大陆',
    director: '陈墨白',
    actors: ['林澈', '苏晚', '周决', '孟青禾'],
    rating: 9.2,
    views: 12860000,
    updateStatus: 'HD高清',
    updatedAt: '2026-10-10',
    summary:
      '一场跨越大半个银河的归途。为了寻找失联多年的深空探测船，宇航员顾言独自穿越虫洞，却在彼岸发现了一个关于人类未来的惊人答案。',
    hot: true,
  },
  {
    id: 'ml-02',
    title: '暗夜追光',
    category: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Neo%20noir%20crime%20thriller%20movie%20poster%2C%20rain%20slicked%20city%20street%20at%20night%2C%20detective%20silhouette%20under%20green%20neon%20glow%2C%20cinematic%20contrast%2C%20moody%20vertical%20art%20direction%2C%20highly%20detailed&width=600&height=900&seq=nc-movie-02&orientation=portrait',
    genre: ['悬疑', '犯罪', '剧情'],
    year: 2026,
    region: '中国大陆',
    director: '高岩',
    actors: ['沈默', '江雨', '陆行舟'],
    rating: 9.0,
    views: 11240000,
    updateStatus: 'HD高清',
    updatedAt: '2026-10-09',
    summary:
      '连环失踪案背后藏着被掩盖二十年的真相。刑警队长沈砚循着一缕微光追查，却发现真相的尽头站着自己最不愿面对的人。',
    hot: true,
  },
  {
    id: 'ml-03',
    title: '迷雾之城',
    category: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Suspense%20mystery%20film%20poster%2C%20dense%20fog%20covering%20a%20sleepy%20town%2C%20lone%20figure%20with%20lantern%20walking%20narrow%20alley%2C%20muted%20teal%20and%20grey%20palette%2C%20cinematic%20vertical%20composition%2C%20atmospheric&width=600&height=900&seq=nc-movie-03&orientation=portrait',
    genre: ['悬疑', '惊悚', '剧情'],
    year: 2025,
    region: '美国',
    director: 'David Greene',
    actors: ['Ethan Hale', 'Maria Quinn', 'Noah Reed'],
    rating: 8.7,
    views: 9860000,
    updateStatus: 'HD高清',
    updatedAt: '2026-10-08',
    summary:
      '一座终年被浓雾笼罩的海岸小镇，每隔七年就会有人消失。新来的警长发现，雾里藏着整个小镇共同守护的秘密。',
    hot: false,
  },
  {
    id: 'ml-04',
    title: '山海回声',
    category: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Epic%20fantasy%20adventure%20poster%2C%20ancient%20mythical%20mountains%20and%20sea%2C%20glowing%20spirit%20creature%20soaring%20above%20cliffs%2C%20jade%20green%20and%20gold%20tones%2C%20grand%20vertical%20cinematic%20composition&width=600&height=900&seq=nc-movie-04&orientation=portrait',
    genre: ['奇幻', '动作', '冒险'],
    year: 2026,
    region: '中国大陆',
    director: '徐川',
    actors: ['顾南辰', '白鹭', '江照'],
    rating: 8.5,
    views: 8720000,
    updateStatus: 'HD高清',
    updatedAt: '2026-10-07',
    summary:
      '上古山海异兽重现人间，少年守山人唤醒沉睡的古老契约，踏上一段穿越山与海的奇幻旅程，只为守住最后的回声。',
    hot: false,
  },
  {
    id: 'ml-05',
    title: '孤岛救援',
    category: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Action%20disaster%20movie%20poster%2C%20lone%20rescue%20helicopter%20over%20stormy%20ocean%20island%2C%20crashing%20waves%2C%20dramatic%20amber%20sky%2C%20cinematic%20adventure%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=nc-movie-05&orientation=portrait',
    genre: ['动作', '冒险', '灾难'],
    year: 2025,
    region: '韩国',
    director: '朴承宇',
    actors: ['金志勋', '韩素拉', '李在赫'],
    rating: 8.3,
    views: 7540000,
    updateStatus: 'HD高清',
    updatedAt: '2026-10-06',
    summary:
      '一场百年不遇的风暴摧毁了海上钻井平台。退役救援队员必须在十二小时内穿越风暴，救出被困孤岛上的最后一批工人。',
    hot: false,
  },
  {
    id: 'ml-06',
    title: '时间褶皱',
    category: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Mind%20bending%20sci%20fi%20drama%20poster%2C%20fractured%20clock%20faces%20floating%20in%20a%20dark%20void%2C%20glowing%20green%20time%20particles%2C%20surreal%20abstract%20vertical%20composition%2C%20elegant%20cinematic%20design&width=600&height=900&seq=nc-movie-06&orientation=portrait',
    genre: ['科幻', '剧情', '悬疑'],
    year: 2026,
    region: '英国',
    director: 'Eleanor Blake',
    actors: ['Oliver Finch', 'Grace Nolan', 'Tom Ashby'],
    rating: 9.1,
    views: 10980000,
    updateStatus: 'HD高清',
    updatedAt: '2026-10-05',
    summary:
      '物理学家在一次实验事故后发现自己每天醒来都会回到同一天。她必须在无数次循环中找出那个改变一切的瞬间。',
    hot: true,
  },
  {
    id: 'ml-07',
    title: '铁血长空',
    category: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Historical%20war%20epic%20movie%20poster%2C%20vintage%20fighter%20planes%20flying%20through%20golden%20smoke%20filled%20sky%2C%20brave%20pilot%20silhouette%2C%20warm%20sepia%20and%20olive%20tones%2C%20vertical%20cinematic%20art&width=600&height=900&seq=nc-movie-07&orientation=portrait',
    genre: ['战争', '历史', '剧情'],
    year: 2025,
    region: '中国大陆',
    director: '王铮',
    actors: ['张国栋', '刘远', '孙浩'],
    rating: 8.9,
    views: 9120000,
    updateStatus: 'HD高清',
    updatedAt: '2026-10-04',
    summary:
      '一支年轻的飞行队用生命守护祖国的天空。当最后一架战机冲向敌阵，长空之上写下了永不褪色的铁血荣光。',
    hot: false,
  },
  {
    id: 'ml-08',
    title: '春日告白',
    category: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Romantic%20drama%20movie%20poster%2C%20young%20couple%20under%20blooming%20cherry%20blossom%20trees%2C%20soft%20warm%20sunlight%2C%20gentle%20pastel%20green%20and%20pink%20palette%2C%20tender%20vertical%20composition&width=600&height=900&seq=nc-movie-08&orientation=portrait',
    genre: ['爱情', '剧情', '治愈'],
    year: 2026,
    region: '日本',
    director: '佐藤健一',
    actors: ['新垣阳菜', '山田悠真', '小林枫'],
    rating: 8.4,
    views: 6980000,
    updateStatus: 'HD高清',
    updatedAt: '2026-10-03',
    summary:
      '两个在春天相遇的人，用一整个季节写了一封没能寄出的告白。多年后重逢，他们终于读懂了那年春天的风。',
    hot: false,
  },
  {
    id: 'ml-09',
    title: '深海觉醒',
    category: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Deep%20sea%20sci%20fi%20thriller%20poster%2C%20submarine%20descending%20into%20glowing%20abyssal%20trench%2C%20bioluminescent%20creature%20eyes%20in%20darkness%2C%20deep%20green%20and%20black%20tonality%2C%20vertical%20cinematic&width=600&height=900&seq=nc-movie-09&orientation=portrait',
    genre: ['科幻', '惊悚', '冒险'],
    year: 2025,
    region: '美国',
    director: 'Marcus Vale',
    actors: ['Liam Cross', 'Ava Stone', 'Ryan Ford'],
    rating: 8.6,
    views: 8450000,
    updateStatus: 'HD高清',
    updatedAt: '2026-10-02',
    summary:
      '深潜器在万米海沟失联，救援潜艇发现那里生活着从未被记录的生命。当深海开始觉醒，人类才明白自己没有想象中强大。',
    hot: true,
  },
  {
    id: 'ml-10',
    title: '逆流而上',
    category: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Inspirational%20family%20drama%20movie%20poster%2C%20father%20and%20daughter%20rowing%20a%20small%20boat%20upstream%20on%20a%20golden%20river%2C%20warm%20sunrise%20light%2C%20hopeful%20green%20and%20amber%20tones%2C%20vertical%20composition&width=600&height=900&seq=nc-movie-10&orientation=portrait',
    genre: ['剧情', '家庭', '励志'],
    year: 2026,
    region: '中国大陆',
    director: '李安然',
    actors: ['赵德海', '陈小雨', '吴建国'],
    rating: 8.8,
    views: 7230000,
    updateStatus: 'HD高清',
    updatedAt: '2026-10-01',
    summary:
      '一个破产的父亲，一个不愿认输的女儿，一条逆流而上的小船。他们用最笨拙的方式，划出了属于普通人的尊严。',
    hot: false,
  },
  {
    id: 'ml-11',
    title: '幻影迷城',
    category: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Cyberpunk%20suspense%20movie%20poster%2C%20futuristic%20city%20with%20holographic%20mirror%20reflections%2C%20mysterious%20figure%20in%20long%20coat%2C%20green%20and%20amber%20neon%20glow%2C%20vertical%20cinematic%20art%20direction&width=600&height=900&seq=nc-movie-11&orientation=portrait',
    genre: ['悬疑', '科幻', '犯罪'],
    year: 2025,
    region: '中国香港',
    director: '麦兆辉',
    actors: ['林嘉俊', '周慧敏', '黄志强'],
    rating: 8.2,
    views: 6120000,
    updateStatus: 'HD高清',
    updatedAt: '2026-09-30',
    summary:
      '一桩看似普通的诈骗案，牵出一座用幻影搭建的迷城。当现实与投影真假难辨，侦探只能相信自己的记忆。',
    hot: false,
  },
  {
    id: 'ml-12',
    title: '雪原猎手',
    category: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Snow%20adventure%20action%20poster%2C%20lone%20hunter%20trekking%20through%20endless%20frozen%20wilderness%2C%20grey%20wolf%20shadow%20in%20blizzard%2C%20cold%20icy%20blue%20white%20and%20dark%20green%20palette%2C%20vertical%20cinematic&width=600&height=900&seq=nc-movie-12&orientation=portrait',
    genre: ['动作', '冒险', '剧情'],
    year: 2026,
    region: '法国',
    director: 'Luc Moreau',
    actors: ['Antoine Petit', 'Claire Dubois', 'Hugo Laurent'],
    rating: 8.0,
    views: 5430000,
    updateStatus: 'HD高清',
    updatedAt: '2026-09-29',
    summary:
      '退休猎人为兑现一个承诺，独自穿越暴风雪追踪一头传说中的白狼。在极寒尽头，他追捕的其实是自己的过去。',
    hot: false,
  },
  {
    id: 'ml-13',
    title: '昨日晴空',
    category: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Nostalgic%20youth%20romance%20poster%2C%20two%20students%20on%20a%20sunny%20school%20rooftop%20with%20clouds%2C%20bicycle%20and%20blue%20sky%2C%20soft%20warm%20green%20and%20golden%20light%2C%20gentle%20vertical%20composition&width=600&height=900&seq=nc-movie-13&orientation=portrait',
    genre: ['爱情', '青春', '剧情'],
    year: 2025,
    region: '中国台湾',
    director: '林清和',
    actors: ['陈柏睿', '许晴', '王亦凡'],
    rating: 8.5,
    views: 6870000,
    updateStatus: 'HD高清',
    updatedAt: '2026-09-28',
    summary:
      '毕业那年夏天，他们没有说再见。十年后的同学会上，一叠泛黄的照片让昨日的晴空重新照进了今天。',
    hot: false,
  },
  {
    id: 'ml-14',
    title: '钢铁纪元',
    category: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Action%20sci%20fi%20blockbuster%20poster%2C%20giant%20mecha%20robot%20standing%20over%20a%20ruined%20city%2C%20glowing%20green%20energy%20core%2C%20epic%20scale%2C%20amber%20sunset%20smoke%2C%20vertical%20cinematic%20composition&width=600&height=900&seq=nc-movie-14&orientation=portrait',
    genre: ['科幻', '动作', '冒险'],
    year: 2026,
    region: '美国',
    director: 'Nathan Cole',
    actors: ['Chris Dalton', 'Sophia Reyes', 'Mark Bell'],
    rating: 8.9,
    views: 12050000,
    updateStatus: 'HD高清',
    updatedAt: '2026-09-27',
    summary:
      '当最后一台钢铁机甲被唤醒，人类与机械文明的百年之战迎来终局。驾驶舱里的少年，握住了整个纪元的命运。',
    hot: true,
  },
  {
    id: 'tv-01',
    title: '长夜将明',
    category: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Crime%20suspense%20tv%20series%20poster%2C%20brooding%20detective%20in%20dark%20corridor%20with%20single%20green%20light%2C%20rain%20streaked%20window%2C%20moody%20cinematic%20vertical%20design%2C%20high%20detail&width=600&height=900&seq=nc-tv-01&orientation=portrait',
    genre: ['悬疑', '犯罪', '剧情'],
    year: 2026,
    region: '中国大陆',
    director: '张力',
    actors: ['段奕风', '宋佳', '王凯'],
    rating: 9.3,
    views: 15600000,
    updateStatus: '更新至第18集',
    updatedAt: '2026-10-10',
    summary:
      '一桩尘封十年的悬案重启，退休刑警与年轻检察官联手追凶。越接近真相，长夜中的那道光就越危险。',
    hot: true,
  },
  {
    id: 'tv-02',
    title: '都市浮生记',
    category: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Urban%20drama%20tv%20series%20poster%2C%20young%20professionals%20on%20a%20city%20rooftop%20at%20dusk%2C%20glowing%20skyscrapers%20behind%2C%20warm%20green%20and%20amber%20lights%2C%20cinematic%20vertical%20composition&width=600&height=900&seq=nc-tv-02&orientation=portrait',
    genre: ['都市', '剧情', '情感'],
    year: 2026,
    region: '中国大陆',
    director: '周晓',
    actors: ['刘畅', '杨紫', '李现', '张予曦'],
    rating: 8.7,
    views: 13200000,
    updateStatus: '更新至第24集',
    updatedAt: '2026-10-09',
    summary:
      '四个大学同窗在都市打拼十年，有人登顶，有人坠落。当生活的滤镜被摘下，他们重新学会了如何做自己。',
    hot: true,
  },
  {
    id: 'tv-03',
    title: '山河令序',
    category: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Ancient%20chinese%20wuxia%20tv%20poster%2C%20two%20swordsmen%20on%20misty%20mountain%20peaks%2C%20flowing%20robes%20in%20wind%2C%20jade%20green%20and%20gold%20palette%2C%20elegant%20vertical%20cinematic%20composition&width=600&height=900&seq=nc-tv-03&orientation=portrait',
    genre: ['古装', '武侠', '剧情'],
    year: 2025,
    region: '中国大陆',
    director: '李木戈',
    actors: ['龚俊', '张哲瀚', '周也'],
    rating: 9.0,
    views: 14100000,
    updateStatus: '全剧完结',
    updatedAt: '2026-10-08',
    summary:
      '一段被江湖遗忘的旧约，让两个本不该相遇的人并肩而立。山河作序，他们的故事写进了每个观众心里。',
    hot: false,
  },
  {
    id: 'tv-04',
    title: '医者仁心',
    category: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Medical%20drama%20tv%20series%20poster%2C%20surgeon%20in%20green%20scrubs%20in%20bright%20hospital%20corridor%2C%20hopeful%20clean%20atmosphere%2C%20soft%20green%20and%20white%20tones%2C%20vertical%20cinematic%20design&width=600&height=900&seq=nc-tv-04&orientation=portrait',
    genre: ['医疗', '剧情', '职场'],
    year: 2026,
    region: '中国大陆',
    director: '张黎',
    actors: ['靳东', '白百何', '朱亚文'],
    rating: 8.9,
    views: 11800000,
    updateStatus: '更新至第12集',
    updatedAt: '2026-10-07',
    summary:
      '急诊科的每一秒都是生死抉择。一群医生在高压与理想之间，守住那句“医者仁心”的承诺。',
    hot: false,
  },
  {
    id: 'tv-05',
    title: '沉默的证词',
    category: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Korean%20crime%20thriller%20tv%20poster%2C%20empty%20courtroom%20with%20single%20hanging%20light%2C%20silhouette%20of%20a%20woman%20holding%20a%20file%2C%20moody%20dark%20green%20tones%2C%20vertical%20cinematic&width=600&height=900&seq=nc-tv-05&orientation=portrait',
    genre: ['悬疑', '犯罪', '剧情'],
    year: 2025,
    region: '韩国',
    director: '金敏植',
    actors: ['朴信阳', '李宝英', '赵震雄'],
    rating: 9.1,
    views: 12400000,
    updateStatus: '全剧完结',
    updatedAt: '2026-10-06',
    summary:
      '一位法医为死者发声二十年，直到自己也成为沉默的证词。真相被层层掩埋，她要用最后的证据让法庭听见。',
    hot: true,
  },
  {
    id: 'tv-06',
    title: '星辰大海',
    category: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Space%20sci%20fi%20tv%20series%20poster%2C%20crew%20standing%20before%20huge%20space%20station%20window%20with%20green%20planet%2C%20cinematic%20stars%20and%20starship%2C%20epic%20vertical%20composition&width=600&height=900&seq=nc-tv-06&orientation=portrait',
    genre: ['科幻', '剧情', '冒险'],
    year: 2026,
    region: '美国',
    director: 'Eric Shaw',
    actors: ['Daniel West', 'Nina Cole', 'Owen Hart'],
    rating: 8.8,
    views: 10600000,
    updateStatus: '更新至第8集',
    updatedAt: '2026-10-05',
    summary:
      '人类第一艘星际殖民船驶向未知星系。当故乡的讯号中断，船员们要在星辰与大海之间，重新定义“回家”。',
    hot: false,
  },
  {
    id: 'tv-07',
    title: '城南旧事新篇',
    category: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20family%20period%20drama%20poster%2C%20old%20chinese%20town%20alley%20with%20lanterns%20and%20bicycles%2C%20three%20generations%20family%20portrait%2C%20nostalgic%20green%20and%20amber%20tones%2C%20vertical&width=600&height=900&seq=nc-tv-07&orientation=portrait',
    genre: ['家庭', '年代', '剧情'],
    year: 2025,
    region: '中国大陆',
    director: '孔笙',
    actors: ['范伟', '周迅', '易烊千玺'],
    rating: 8.6,
    views: 9700000,
    updateStatus: '全剧完结',
    updatedAt: '2026-10-04',
    summary:
      '老城南的一家人，从胡同搬进高楼，从黑白电视看到手机直播。旧事翻出新篇，唯有那一饭一蔬的温情不变。',
    hot: false,
  },
  {
    id: 'tv-08',
    title: '权谋之局',
    category: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Chinese%20historical%20palace%20intrigue%20tv%20poster%2C%20emperor%20on%20throne%20in%20dim%20grand%20hall%2C%20candlelight%20and%20green%20bronze%20details%2C%20dramatic%20vertical%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=nc-tv-08&orientation=portrait',
    genre: ['古装', '历史', '权谋'],
    year: 2026,
    region: '中国大陆',
    director: '郑晓龙',
    actors: ['陈道明', '胡歌', '刘涛'],
    rating: 9.2,
    views: 14900000,
    updateStatus: '更新至第30集',
    updatedAt: '2026-10-03',
    summary:
      '庙堂之上，一步错满盘输。年轻的谋士卷入皇权更迭的漩涡，用一场惊心动魄的权谋之局改写王朝命运。',
    hot: true,
  },
  {
    id: 'tv-09',
    title: '青春不散场',
    category: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Youth%20romance%20tv%20poster%2C%20group%20of%20college%20friends%20laughing%20on%20campus%20lawn%20at%20sunset%2C%20warm%20green%20and%20golden%20light%2C%20fresh%20energetic%20vertical%20composition&width=600&height=900&seq=nc-tv-09&orientation=portrait',
    genre: ['青春', '爱情', '剧情'],
    year: 2025,
    region: '中国大陆',
    director: '赵小溪',
    actors: ['谭松韵', '张新成', '丁禹兮'],
    rating: 8.3,
    views: 8400000,
    updateStatus: '全剧完结',
    updatedAt: '2026-10-02',
    summary:
      '大学四年，六个室友，一段兵荒马乱又闪闪发光的青春。散场那天他们约定，谁都不许把这段日子忘掉。',
    hot: false,
  },
  {
    id: 'tv-10',
    title: '未来档案',
    category: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Japanese%20sci%20fi%20mystery%20tv%20poster%2C%20detective%20looking%20at%20floating%20holographic%20data%20files%2C%20dark%20room%20with%20green%20glow%2C%20cinematic%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=nc-tv-10&orientation=portrait',
    genre: ['科幻', '悬疑', '剧情'],
    year: 2026,
    region: '日本',
    director: '石川庆',
    actors: ['樱井翔', '长泽雅美', '松重丰'],
    rating: 8.9,
    views: 10100000,
    updateStatus: '更新至第10集',
    updatedAt: '2026-10-01',
    summary:
      '在不远的未来，所有人的记忆都可被归档。一名档案管理员发现了一份不属于任何人的“未来档案”，从此被卷入巨大阴谋。',
    hot: false,
  },
];